import type { TttChrome } from "@/components/ttt/types"

interface FooterProps {
  chrome: TttChrome
}

const linkClass =
  "block font-ttt text-sm text-white hover:text-secondary transition-colors duration-200 hover:translate-x-1 transform transition-transform"

// Faithful React port of ttt/common/_footer.
export default function Footer({ chrome }: FooterProps) {
  const { paths, images, social } = chrome
  const year = new Date().getFullYear()

  return (
    <>
      <footer
        className="relative overflow-hidden h-64"
        style={{
          backgroundImage: `url(${images.footer_dots})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="bg-contour w-full">
        <div className="container mx-auto pb-16 px-6 lg:px-8 max-w-6xl relative">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            <div className="lg:col-span-4 space-y-6 uppercase">
              <p className="font-ttt text-sm text-white leading-relaxed max-w-sm">
                Association loi 1901 dédiée à l'édition et la diffusion culturelle. Plateforme
                éditoriale moderne pour les créateurs et collectifs artistiques.
              </p>
              <div className="pt-4">
                <div className="flex gap-4 text-2xl items-center">
                  {social.instagram && (
                    <a href={social.instagram} target="_blank" rel="noreferrer">
                      <i className="fa-brands fa-instagram text-white hover:text-secondary transition-colors duration-200" />
                    </a>
                  )}
                  {social.facebook && (
                    <a href={social.facebook} target="_blank" rel="noreferrer">
                      <i className="fa-brands fa-facebook text-white hover:text-secondary transition-colors duration-200" />
                    </a>
                  )}
                </div>
              </div>
            </div>

            <div className="lg:col-span-8 uppercase">
              <div className="grid grid-cols-2 md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <nav className="space-y-3">
                    <a href={paths.mentions_legales} className={linkClass}>
                      Mentions légales
                    </a>
                    <a href={paths.confidentiality} className={linkClass}>
                      Confidentialité
                    </a>
                    <a href={paths.cgv} className={linkClass}>
                      CGV
                    </a>
                    <a href={paths.cookies} className={linkClass}>
                      Cookies
                    </a>
                  </nav>
                </div>
                <div className="space-y-4">
                  <nav className="space-y-3">
                    <a href={paths.store} className={linkClass}>
                      Boutique
                    </a>
                    <a href={paths.authors} className={linkClass}>
                      Auteur.ices
                    </a>
                  </nav>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-contour border-opacity-50 uppercase">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <p className="font-ttt text-xs text-white text-center md:text-left flex items-center space-x-2">
                <span>© {year} TTT Corp</span>
                <span className="w-1 h-1 bg-content rounded-full hidden md:block" />
                <span className="text-white">Association loi 1901</span>
                <span className="w-1 h-1 bg-content rounded-full hidden md:block" />
                <span className="text-white">Édition et diffusion culturelle</span>
              </p>
              <div className="flex space-x-1 opacity-60">
                <div className="w-2 h-2 bg-primary transform rotate-45" />
                <div className="w-2 h-2 bg-secondary transform rotate-45" />
                <div className="w-2 h-2 bg-content transform rotate-45" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
